import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { DELIVERY } from "@/constants/testIds";

export default function AdminDeliveryConfig() {
  const { user } = useAuth();
  const isMaster = user?.roles?.includes("master_admin");
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);

  const reload = async () => {
    try { const { data } = await api.get("/admin/delivery/config"); setCfg(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const save = async () => {
    setBusy(true); setErr(""); setOk(false);
    try {
      await api.put("/admin/delivery/config", {
        base_fee_cents: cfg.base_fee_cents, per_mile_cents: cfg.per_mile_cents,
        territory_multipliers: cfg.territory_multipliers || {},
      });
      setOk(true); setTimeout(() => setOk(false), 1500); await reload();
    } catch (e) { setErr(apiErrorMessage(e)); }
    finally { setBusy(false); }
  };

  if (!cfg) return <div className="font-bebas tracking-[0.3em] text-lifted-dim">LOADING…</div>;

  return (
    <div data-testid={DELIVERY.config} className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Delivery admin</div>
        <h1 className="headline-xl">Fee config</h1>
        <p className="text-lifted-dim mt-2 text-sm max-w-2xl">
          Global delivery fee. Until set, every completed delivery's earning row lands as <code className="text-lifted-text">pending_review · $0</code>.
          Zone-level overrides win when present. {!isMaster && <span className="text-rose-300 ml-2">Read-only — master_admin only.</span>}
        </p>
      </header>
      {err && <div className="text-rose-300 text-sm">{err}</div>}
      <section className="glass-panel p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="lifted-label">Base fee (¢)</label>
            <input data-testid={DELIVERY.configBase} type="number" className="input-lifted" value={cfg.base_fee_cents ?? ""} onChange={(e) => setCfg({ ...cfg, base_fee_cents: e.target.value === "" ? null : parseInt(e.target.value,10) })} disabled={!isMaster} placeholder="not configured" />
          </div>
          <div>
            <label className="lifted-label">Per-mile (¢)</label>
            <input data-testid={DELIVERY.configPerMile} type="number" className="input-lifted" value={cfg.per_mile_cents ?? ""} onChange={(e) => setCfg({ ...cfg, per_mile_cents: e.target.value === "" ? null : parseInt(e.target.value,10) })} disabled={!isMaster} placeholder="not configured" />
          </div>
        </div>
        <button data-testid={DELIVERY.configSave} onClick={save} disabled={busy || !isMaster} className="btn-lifted mt-5 !text-[0.7rem] disabled:opacity-40">
          {busy ? "Saving…" : ok ? "Saved" : "Save config"}
        </button>
      </section>
    </div>
  );
}
